import { useTranslation } from 'react-i18next';
import { UserLocation } from '../../redux/user/userSlice';
import { formatAdditionalLocationInfo } from './LocationSelectorModal/utils';
import { colors } from '../../theme/colors';
import spacing from '../../theme/spacing';
import { fontSize } from '../../theme/typography';

const LocationItemContent = ({
  location,
  isSelected,
  selectedColor,
}: {
  location: UserLocation;
  isSelected: boolean;
  selectedColor?: string;
}) => {
  const additionalLocationInfo = formatAdditionalLocationInfo(location);
  const { t, i18n } = useTranslation();
  return (
    <>
      {location.region && (
        <div
          style={{
            color: isSelected
              ? selectedColor || colors.textPrimary
              : colors.textPrimary,
            fontSize: fontSize.md,
            fontWeight: isSelected ? '500' : 'normal',
          }}
        >
          {location.region}
        </div>
      )}

      {additionalLocationInfo && (
        <div
          style={{
            color: isSelected
              ? selectedColor || colors.textPrimary
              : colors.textGreyMedium,
            fontSize: fontSize.sm,
            marginTop: spacing.xxs,
          }}
        >
          {additionalLocationInfo}
        </div>
      )}

      {location.region && additionalLocationInfo && (
        <div
          style={{
            color: colors.textGreyMedium,
            fontSize: fontSize.xs,
            marginTop: spacing.small,
          }}
        >
          {t('location.publiclyVisible')}: {location.region}
        </div>
      )}
    </>
  );
};

export default LocationItemContent;
